import { logger } from '@gem/modules/logger';

import { IKeyPackage, KeyPackageAlgorithm } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

export const uploadKeyPackages = async (
  missingCount: number,
  isUntrusted?: boolean
): Promise<void> => {
  try {
    const keyPackages: IKeyPackage[] = [];

    for (let i = 0; i < missingCount; i++) {
      const keyPackage = MlsStorageService.getKeyPackageByteArray();
      keyPackages.push({
        algorithm: KeyPackageAlgorithm.CURVE_25519,
        data: keyPackage,
      });
    }

    await e2eeModel.uploadKeyPackages(keyPackages, isUntrusted);
  } catch (error) {
    logger.get('Tasks').error('e2ee.uploadKeyPackages', error);
  }
};
